import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { baseUrl } from '../config/Global';
import { getData } from '../utils/storage';
import { showToast } from '../components/Toast';
import Loader from '../components/Loader';

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [paymentDetails, setPaymentDetails] = useState(null);
  const [userData, setUserData] = useState(null);

//   useEffect(() => {
//     const verifyPayment = async () => {
//       try {
//         const user = getData('data');
//         const response = await axios.get(`${baseUrl}/users/verify-payment/${user?.id}`);
        
//         if (response.data.status === 'success') {
//           setPaymentDetails(location.state);
//           const userResponse = await axios.get(`${baseUrl}/users/get/${user?.id}`);
//           setUserData(userResponse?.data?.data);
//         } else {
//           navigate('/payment-failed');
//         }
//       } catch (error) {
//         console.error('Error verifying payment:', error);
//         navigate('/payment-failed');
//       } finally {
//         setLoading(false);
//       }
//     };

//     verifyPayment();
//   }, []);

  if (loading) {
    return <Loader />;
  }

  return (
    <div className="bg-gradient-to-br from-lime-50 via-gray-50 to-lime-50 min-h-screen">
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -top-40 -right-40 w-80 h-80 bg-lime-200 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-pulse-slow"></div>
        <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-gray-200 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-pulse-slow"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="text-center mb-12">
          <div className="w-24 h-24 bg-lime-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <svg className="w-12 h-12 text-[#a8e82f]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
          </div>
          <h1 className="text-3xl font-bold text-gray-800 mb-2">Payment Successful!</h1>
          <p className="text-lg text-gray-600">Thank you for your subscription</p>
        </div>

        <div className="bg-white/80 backdrop-blur-lg rounded-2xl shadow-xl p-8 border border-white/20 max-w-3xl mx-auto">
          {/* <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
            <div>
              <h3 className="text-lg font-semibold text-gray-700 mb-2">Plan Details</h3>
              <div className="space-y-2">
                <p className="text-gray-600">
                  <span className="font-medium">Plan Name:</span> {paymentDetails?.plan?.name}
                </p>
                <p className="text-gray-600">
                  <span className="font-medium">Price:</span> ${paymentDetails?.plan?.price?.toFixed(2)}
                </p>
                {paymentDetails?.setupFee > 0 && (
                  <p className="text-gray-600">
                    <span className="font-medium">Setup Fee:</span> ${paymentDetails?.setupFee?.toFixed(2)}
                  </p>
                )}
                <p className="text-gray-600">
                  <span className="font-medium">Total Paid:</span> ${paymentDetails?.paymentAmount?.toFixed(2)}
                </p>
              </div>
            </div>
            
            <div>
              <h3 className="text-lg font-semibold text-gray-700 mb-2">Account Details</h3>
              <div className="space-y-2">
                <p className="text-gray-600">
                  <span className="font-medium">Name:</span> {userData?.name}
                </p>
                <p className="text-gray-600">
                  <span className="font-medium">Email:</span> {userData?.email}
                </p>
                <p className="text-gray-600">
                  <span className="font-medium">Status:</span> <span className="text-lime-500 font-medium">Active</span>
                </p>
              </div>
            </div>
          </div> */}

          <div className="bg-lime-50 rounded-lg p-4 mb-8">
            <div className="flex items-start">
              <svg className="w-5 h-5 text-[#a8e82f] mt-0.5 mr-2 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <p className="text-[#a8e82f">
                Your subscription is now active. You can start using all the features immediately.
              </p>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <button
              onClick={() => navigate('/package')}
              className="px-6 py-3 bg-[#a8e82f] text-black rounded-lg font-medium shadow-md hover:shadow-lg transition-all"
            >
              Go Back to Packages
            </button>
            {/* <button
              onClick={() => navigate('/profile')}
              className="px-6 py-3 bg-white border border-gray-300 text-gray-700 rounded-lg font-medium shadow-sm hover:bg-gray-50 transition-all"
            >
              View Profile
            </button> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccess;